import { SiteTypes } from '../enums';
import { getEndpointURL } from './getEndpointUrl';

export const goToFavourites = () => {
  globalThis.location.href = getEndpointURL(SiteTypes.FAVOURITES);
};
